module.exports = __webpack_public_path__ + "img/home-video4-cover.ecf8e3b5.png";